import styled from "styled-components";
import {DownOutline} from 'antd-mobile-icons'
import {getLastNotice} from '../../api'
import { useEffect, useState } from "react";
import useCommon from "../../hooks/Common/useCommon";
export default function Notice() {
  const [list, setList] = useState([])

  const [show,setShow] = useState(false)
  const {lang} = useCommon()
  useEffect(() => {
    loadList()
  },[])
  const loadList =async () => {
    const res = await getLastNotice({
      lang: lang === 'en' ? 'en' : 'cn',
    })
    const hide_id = window.localStorage.getItem('HIDE_NOTICE_ID')
    const l = res.data.list
    if(hide_id && l[l.length - 1].id == hide_id){
      setList([])
    }else {

    setList(res.data.list)
    }
  }
  return (
    <>
    { list.length ? <Wrapper>
      <Inner onClick={() => {
        setShow(!show)
      }}>
        <img src="/image/notice.svg" alt="notice" />
       {!show ? <Title>{list[list.length - 1].title}</Title>
        :<Text>
          <div>{list[list.length - 1].title}</div>
          <div dangerouslySetInnerHTML={{__html:list[list.length - 1].content}}></div>
        </Text>}
      </Inner>
     { !show ?<DownOutline style={{color:'#FC7B2B'}}/>
      :<CloseIcon src="/image/close.svg" alt="close"  onClick={() => {
        window.localStorage.setItem('HIDE_NOTICE_ID',list[list.length - 1].id)
        setList([])
      }}/>}
    </Wrapper> :null}
    </>
  );
}

const Wrapper = styled.div`
  display: flex;
  background: #fdf4ed;
  border-radius: .6rem;
  padding: .8rem 1.0rem;
  justify-content: space-between;
  align-items: baseline;
`;
const Inner = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
  width: 96%;
`;

const CloseIcon = styled.img`
  width: 1.0rem;
`;
const Title = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 1.3rem;
  line-height: 1.3rem;
  color: #FC7B2B;
  padding: 0 1.0rem 0 .6rem;
  overflow: hidden;
    white-space: nowrap;
    
    text-overflow: ellipsis;
`;
const Text = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 1.3rem;
  line-height: 1.5rem;
  padding: 0 1.0rem 0 .6rem;
  color: #fc7b2b;
`;
